/** Turn a native persisted report snapshot into the report editor's view state. */
export function reportEditorData(report) {
  const data = report.report_data || {};
  const offers = Array.isArray(data.offers) ? data.offers : [];
  const feedback = Array.isArray(data.feedback) ? data.feedback : [];
  return {
    report_id: report.report_id,
    status: report.status,
    reportTitle: report.title,
    offers,
    feedback,
    offerRowOrder: report.row_order?.offers || offers.map((row) => row.id),
    feedbackRowOrder:
      report.row_order?.feedback || feedback.map((row) => row.id),
    columnSettings: report.column_settings || {},
    geoData: report.geo_data || {},
  };
}
